import { Button, RadioButton, Modal, Text, BlockStack, InlineStack, Box, Banner, Card } from '@shopify/polaris';
import { CancelSmallMinor, ExternalMinor } from '@shopify/polaris-icons';
import React, { useEffect, useRef, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { ACTION_TYPE } from '../Context/actiontypes';
import useContainerState from '../Context/ContainerState';
import useContextLayer from '../Context/helper';
import { isPageLoading } from './utils';
import MapAttributeImg from '../../../../Asests/Images/map-attribute.png'
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    loaderHandler: (type: string, value: boolean) => {},
    loader: boolean;
    JSONFeedAttributesData: any
}

function CustomHeader(props: Props): any {
    const { t } = useTranslation();
    const { state, dispatch } = useContextLayer();
    const { containerState, categoryProductType, setCategoryProductType, setJSONFeedAttributesData, setRenderJSONFeed } = useContainerState();

    const newListingProductType = useRef<any>()

    const [modal, setModal] = useState<any>({
        isOpen: false,
        title: '',
        text: '',
        selection_type: ''
    });

    useEffect(() => { }, [state?.['renderComponent']])

    function modifyData(identifier: string) {
        dispatch({
            type: ACTION_TYPE.LISTING_TYPE,
            payload: {
                [ACTION_TYPE.LISTING_TYPE]: identifier
            }
        });
        let test = state?.['attributes_changed'] === identifier ? identifier + state?.['category_settings']?.['primary_category'] : identifier;
        if (identifier === 'offer_listing') {
            dispatch({
                type: ACTION_TYPE.ATTRIBUTES_CHANGED,
                payload: {
                    attributes_changed: test
                }
            });
            newListingProductType.current = { product_type: categoryProductType?.product_type, getData: categoryProductType?.getData }
            setCategoryProductType((a: { oldOrNew: 'old' | 'new', product_type: string | string[], getData?: any, initProfileAttributes?: any, from?: 'edited' | 'profile' }) => ({ ...a, product_type: ['PRODUCT'], getData: {}, currentData: {} }));
            setJSONFeedAttributesData(undefined)
            setRenderJSONFeed(false)
        }
        else {
            test = state?.['listing_type_changed'] === identifier ? test + state?.['category_settings']?.['primary_category'] : identifier
            dispatch({
                type: ACTION_TYPE.ATTRIBUTES_CHANGED,
                payload: {
                    attributes_changed: test
                }
            });
            setCategoryProductType((a: { oldOrNew: 'old' | 'new', product_type: string | string[], getData?: any, initProfileAttributes?: any, from?: 'edited' | 'profile' }) => ({ ...a, product_type: newListingProductType?.current?.product_type, getData: newListingProductType?.current?.getData }));
            setJSONFeedAttributesData(undefined)
            setRenderJSONFeed(false)
        }
    }

    function isDisabled(radioBtn: string) {
        let isDisabled: boolean = false;
        if (containerState['product_type']['variantEdit'] || !containerState.initialProductData['hasVariants']) {
            // if (state?.['parent_details']?.['edited']?.['category_settings']?.['primary_category'] === 'default' && state?.['parent_details']?.['edited']?.['category_settings']?.['sub_category'] === 'default') {
            //     isDisabled = true;
            // }
            // else if (state?.['parent_details']?.['profile_info']?.['edited']?.['category_settings']?.['primary_category'] === 'default' && state?.['parent_details']?.['profile_info']?.['edited']?.['category_settings']?.['sub_category'] === 'default') {
            //     isDisabled = true;
            // }
            // else if (containerState.initialProductData['status'] === AVAILABLE_FOR_OFFER) {
            //     isDisabled = true;
            // }
            // else isDisabled = false
            if (state?.[ACTION_TYPE.LISTING_TYPE] !== radioBtn) {
                isDisabled = true;
            }
        }
        return isDisabled;
    }

    // function renderAsin() {
    //     if (containerState.initialProductData.asin != '') {
    //         let url: any = `http://${getAmazonLink(props)}/dp/${containerState.initialProductData.asin}`;
    //         return <Link external url={url}>View On Amazon </Link>
    //     }
    // }
    return <>
        <Box paddingInlineStart="800" paddingBlockEnd="600">
            <BlockStack gap="400">
                <BlockStack gap="100">
                    <div id='tour_listing_type'>
                        <InlineStack blockAlign='center' gap="400">
                            <Text as='p' fontWeight="semibold" tone='subdued'>{t("List As")}</Text>
                            <RadioButton
                                disabled={isDisabled('offer_listing')}
                                label={<Text as='p' tone='subdued'>{t("Offer Listing")}</Text>}
                                checked={state?.[ACTION_TYPE.LISTING_TYPE] === 'offer_listing'}
                                id="offer_listing"
                                name="accounts"
                                onChange={(index, value) => {
                                    if (isPageLoading(containerState)) {
                                        props.error(t('Page is loading, Kindly wait...'));
                                    } else {
                                        modal.isOpen = true;
                                        modal.selection_type = value.toString();
                                        setModal({ ...modal });
                                    }
                                }}
                            />
                            <RadioButton
                                disabled={isDisabled('new_listing')}
                                label={<Text as='p' tone='subdued'>{t("New Listing")}</Text>}
                                id="new_listing"
                                name="accounts"
                                checked={state?.[ACTION_TYPE.LISTING_TYPE] === 'new_listing'}
                                onChange={(index, value) => {
                                    if (isPageLoading(containerState)) {
                                        props.error(t('Page is loading, Kindly wait...'));
                                    } else {
                                        modal.isOpen = true;
                                        modal.selection_type = value.toString();
                                        setModal({ ...modal });
                                    }
                                }}
                            />
                        </InlineStack>
                    </div>
                    {state?.[ACTION_TYPE.LISTING_TYPE] === 'offer_listing' && <Text as='p'><Text as='span' fontWeight='semibold'>{t("Offer Listing:")}</Text> {t("List a product on Amazon that matches an existing listing, sparing you from the tedious steps of selecting a category, mapping attributes, and creating a new listing from scratch. To know more checkout this guide on Amazon Listing.")}</Text>}
                    {state?.[ACTION_TYPE.LISTING_TYPE] === 'new_listing' && <Text as='p'><Text as='span' fontWeight='semibold'>{t("New Listing:")}</Text> {t("Upload a product on Amazon that is not already listed on Amazon by any merchant and the barcode of that product is unique. Here you need to add a title, description, select a category, and map attributes. To know more checkout this guide on Amazon Listing.")}</Text>}
                    <Text as='p'>{t("To know more checkout this guide on")}{" "}
                        <Button
                            onClick={() => { window.open('https://support.cedcommerce.com/portal/en/kb/articles/offer-listing-vs-new-listing-26-3-2024', '_blank') }}
                            variant="plain">{t("Amazon listings.")}</Button>
                    </Text>
                </BlockStack>
                <AttributeMapBanner />
                {(state?.shopify_data?.edited?.bulk_edit_attributes_mapping && Object.keys(state?.shopify_data?.edited?.bulk_edit_attributes_mapping)?.length > 0 && !props.loader) && <AttributeInfoBanner {...props} JSONFeedAttributesData={props.JSONFeedAttributesData} />}
            </BlockStack>
        </Box>
        <Modal open={modal['isOpen']} onClose={() => {
            modal.isOpen = false;
            setModal({ ...modal });
        }} title={t("Unsaved Changes!")} primaryAction={{
            content: 'Proceed', onAction: () => {
                modifyData(modal.selection_type);
                modal.isOpen = false;
                setModal({ ...modal });
            }
        }}>
            <Modal.Section>
                <Text as='p'>{t("You have unsaved changes in this section. Do you want to continue without saving the changes first?")}</Text>
                <Text as='p'>{t("NOTE: If you proceed now, all the unsaved changes will be lost.")}</Text>
            </Modal.Section>
        </Modal>
    </>;
}
export const AttributeMapBanner = ({ className }: any) => {
    const { t } = useTranslation();
    const [showBanner, setShowBanner] = useState(true);

    if (!showBanner) return null;

    return (
        <div className={`${className ? `custom-listing_banner ${className}` : "custom-listing_banner"}`}>
            <InlineStack gap="300" wrap={false} align='space-between' blockAlign='center'>
                <div className='left-banner--content'>
                    <InlineStack gap="300" wrap={!(window.innerWidth > 992)}>
                        <BlockStack gap="0">
                            <Text as='h4' variant='headingMd' fontWeight='bold'>{t("A better way to map attributes is now here!")}</Text>
                            <Text as="p" variant='bodyMd'>{t("Upgrade your Amazon listings! Simplify uploads with 'Product Type', while saved products & templates remain untouched.")}<span className='custom-link'><Button id="custom-link_btn" variant='tertiary' tone='critical' icon={ExternalMinor} url={'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=the-benefit-of-new-listing-api'} external target='_blank'>{t("Learn more")}</Button></span></Text>
                        </BlockStack>
                        <div className='custom-banner--img'>
                            <img src={MapAttributeImg} alt="map attributes" />
                        </div>
                    </InlineStack>
                </div>
                <Button icon={<span className='custom-icon'><CancelSmallMinor /></span>} variant='tertiary' accessibilityLabel="Add theme" onClick={() => { setShowBanner(false) }} />
            </InlineStack>
        </div>
    )
}

interface AttributeInfoBannerProps extends DIProps {
    JSONFeedAttributesData: any
}

export function AttributeInfoBanner(props: AttributeInfoBannerProps): any {
    const [showBanner, setShowBanner] = useState(true);
    const { state } = useContextLayer();
    const [open, setOpen] = useState<boolean>(false);

    function extractPaths(obj: any, prefix = "", labelPath = "", maxUniqueItems = 1): any {
        let paths: any = [];
        if (obj && typeof obj === "object") {
            if (obj.type === "array" && obj.items) {
                return extractPaths(obj.items, `${prefix}->0`, labelPath, obj.maxUniqueItems || 1);
            }
            if (obj.type === "object" && obj.properties) {
                return Object.keys(obj.properties).flatMap((key) => {
                    if (key !== "marketplace_id" && key !== "language_tag") {
                        const newPrefix = prefix ? `${prefix}->${key}` : key;
                        const newLabelPath = labelPath
                            ? `${labelPath}->${obj.properties[key].title}`
                            : obj.properties[key].title;
                        return extractPaths(obj.properties[key], newPrefix, newLabelPath, obj.properties[key].maxUniqueItems || 1);
                    }
                    return [];
                });
            }
            if (!obj.properties && !obj.items) {
                for (let i = 1; i <= maxUniqueItems; i++) {
                    const indexSuffix = maxUniqueItems > 1 ? ` ${i}` : "";
                    const finalLabel = `${labelPath} (${prefix.split("->").pop()})${indexSuffix}`;
                    const finalValue = prefix.replace(/->/g, ".").trim();
                    const indexedValue = maxUniqueItems > 1 ? `${finalValue}.${i}` : finalValue;
                    paths.push({
                        label: finalLabel,
                        value: indexedValue,
                        checked: false,
                    });
                }
            }
        }
        return paths;
    }

    function processData(data: any) {
        return Object.keys(data).flatMap((sectionKey) => {
            const section = data[sectionKey];
            if (typeof section === "object") {
                const attributes = { ...section.Mandatory, ...section.Optional };
                return Object.keys(attributes).flatMap((attrKey) =>
                    extractPaths(attributes[attrKey], attrKey, attributes[attrKey]?.title || "", attributes[attrKey]?.maxUniqueItems || 1)
                );
            }
            return [];
        });
    }

    function matchPaths(obj1: any, obj2: any) {
        const obj2Paths = processData(obj2);
        let matchedPaths: any = {};

        for (const key in obj1) {
            obj2Paths.forEach(path => {
                if (path.value.toLowerCase().includes(key.toLowerCase())) {
                    matchedPaths[key] = path.label;
                }
            });
        }
        return matchedPaths;
    }

    const obj1 = state?.shopify_data?.edited?.bulk_edit_attributes_mapping;
    const obj2 = props?.JSONFeedAttributesData?.attributes;
    const result = matchPaths(obj1, obj2) ?? {};
    const resultValues: any = Object.values(result);

    const getAttributesPaths = () => {
        if (!open) return resultValues.slice(0, 2).map((attr: any, index: number) => {
            return (
                <span key={index}>
                    <Text as="span" fontWeight="bold">{attr}</Text>
                    {index !== 1 ? ", " : ""}
                </span>
            );
        });
        else return resultValues.map((attr: any, index: number) => {
            return (
                <span key={index}>
                    <Text as="span" fontWeight="bold">{attr}</Text>
                    {index !== resultValues.length - 1 ? ", " : ""}
                </span>
            );
        });
    };

    return (
        showBanner ? <div className='custom-attribute-info__banner'><Card padding={"0"}>
            <Banner stopAnnouncements tone='info' title="Some attributes of this product have already been mapped using bulk attribute edit." onDismiss={() => setShowBanner(false)}>
                <div className='custom-attribute-info__textDesc'>
                    <InlineStack gap={"100"} blockAlign='center' align='start'>
                        <Text as='span' variant='bodySm' tone='magic' fontWeight='medium'>Mapped Attributes:</Text>
                        <Text as='span' variant='bodySm' tone='magic' fontWeight='regular'>{getAttributesPaths()}</Text>
                        {!open && resultValues?.length > 2 && <Text as='span' variant='bodySm' tone='magic' fontWeight='medium'>   .... </Text>}
                        {resultValues?.length > 2 && <Button variant='plain' onClick={() => setOpen(!open)}>{!open ? "View more" : "View less"}</Button>}
                    </InlineStack>
                </div>
            </Banner>
        </Card></div> : <></>
    )
}
export default DI(CustomHeader);